import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { OperationRunSheets } from '../../features/operations/operation-bills-of-operations';
import { OperationDetailShell } from '../../features/operations/operation-detail-shell';
import { operationBreadcrumbBadges } from '../../features/operations/operation-route-chrome';
import { OperationRulesList } from '../../features/operations/operation-rules-list';
import {
  operationDetailQueryOptions,
  operationRulesQueryOptions,
} from '../../features/operations/queries';

export const Route = createFileRoute('/operations/$operation_id_/run_sheets')({
  staticData: {
    breadcrumb: (match, queryClient) => {
      const { operation_id: operationId } = match.params as { operation_id: string };
      const data = queryClient.getQueryData(operationDetailQueryOptions(operationId).queryKey);
      return data ? `${data.operation_name} — Run Sheets` : 'Operation Run Sheets';
    },
    breadcrumbBadges: operationBreadcrumbBadges,
    layout: 'full-height',
  },
  component: OperationRunSheetsPage,
});

function OperationRunSheetsPage() {
  const { operation_id: operationId } = Route.useParams();
  const { data: rules } = useQuery(operationRulesQueryOptions(operationId));
  const hasRules = (rules?.length ?? 0) > 0;

  return (
    <OperationDetailShell operationId={operationId} active="run_sheets">
      {(_operation, partnerId) => (
        <div className="flex flex-col gap-8 p-6">
          <section>
            <h3 className="mb-2 text-lg font-medium">Rules</h3>
            <p className="text-muted-foreground mb-3 text-sm">
              Rules decide which Products need this Operation.
            </p>
            <OperationRulesList operationId={operationId} partnerId={partnerId} />
          </section>

          <section>
            <h3 className="mb-2 text-lg font-medium">Used by these Run Sheets</h3>
            <p className="text-muted-foreground mb-3 text-sm">
              Edits to this Operation create a new version of each Run Sheet listed below. To roll
              the new version onto Work Orders, open the Run Sheets matrix and click Release on the
              affected products.
            </p>
            <OperationRunSheets operationId={operationId} hasRules={hasRules} />
          </section>
        </div>
      )}
    </OperationDetailShell>
  );
}
